import {BaseLS} from './BaseLS';
import {IEnum} from '../../../@types/enum';

const STORAGE_KEY = 'displayAspectRatio';

export class DisplayAspectRatio extends BaseLS<IEnum> {
  constructor() {
    super(STORAGE_KEY);
  }
}
